module.exports = __webpack_public_path__ + "static/media/video.04a86a08.mp4";